import CommonButton from "@components/CommonButton";
import {
  updateFocusType,
  updateVideoType,
  selectNewCardsCount,
  selectProcessingItems,
  showTrashDisplay,
} from "../librarySlice";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { Tabs, TabOption } from "@src/ui/Tabs";
import classNames from "classnames";
import { useEffect } from "react";
import { Trans } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { IconDelete } from "@icons/index";

const tabOptions: TabOption[] = [
  { value: "video", label: "Videos", badge: 0 },
  { value: "image", label: "Images" },
  { value: "script", label: "Scripts" },
  { value: "product", label: "Products" },
];

const contentFilterBaseOptions = [
  { value: "generated", label: "Generated" },
  { value: "saved", label: "Saved" },
];

interface HeaderProps {
  addGroup?: () => void;
  className?: string;
}

const Header = ({ className }: HeaderProps) => {
  const dispatch = useAppDispatch();
  const { focusType, videoType } = useAppSelector((state) => state.libraryReducer);
  const newCardsCount = useAppSelector(selectNewCardsCount);
  const processingItems = useAppSelector(selectProcessingItems);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get("type");
    if (type) {
      dispatch(updateFocusType(type));
    }
  }, []);

  // Video tab: 有进行中任务时显示数字角标
  const tabOptionsWithBadge = tabOptions.map((opt) => {
    if (opt.value === "video") {
      return { ...opt, badge: processingItems.length };
    }
    return opt;
  });

  // Generated tab: 有新未查看产物时显示小红点
  const contentFilterOptions = contentFilterBaseOptions.map((opt) => {
    if (opt.value === "generated") {
      return { ...opt, dot: newCardsCount > 0 };
    }
    return opt;
  });

  return (
    <div className={classNames("filterWrap", className)}>
      <div className="flex justify-between gap-[16px]">
        <Tabs
          value={focusType}
          options={tabOptionsWithBadge}
          onChange={(value) => {
            dispatch(updateFocusType(value));
          }}
        />
        <CommonButton onClick={() => dispatch(showTrashDisplay())}>
          <IconDelete className="w-[16px] h-[16px] [&_path]:stroke-current" />
          <Trans>Trash</Trans>
        </CommonButton>
      </div>
      {focusType === "video" && (
        <div className="flex flex-row items-center gap-[16px] mt-[16px]">
          <Tabs
            type="text"
            value={videoType}
            options={contentFilterOptions}
            onChange={(value) => {
              dispatch(updateVideoType(value));
            }}
          />
        </div>
      )}
    </div>
  );
};

export { Header };
